import React, { useEffect, useMemo, useState } from "react";
import { Formik, FieldArray, useFormikContext } from "formik"; // Formik aur useFormikContext ko yahan se import karein

import Index from "../../../../container/Index";
import { useTheme } from "@mui/material/styles";

import PagesIndex from "../../../PagesIndex";
import { Autocomplete, Tooltip, tooltipClasses } from "@mui/material";

import moment from "moment";
import dayjs from "dayjs";

import SwapVertIcon from "@mui/icons-material/SwapVert";
import {
  getAllBankList,
  getDisbursementDataList,
  addMassDisbursementData,
} from "../../../../redux/features/AddService";
import { massDisbursementSchema } from "../../../../validation/Validation";

import { imagePath } from "../../../../config/DataService";
import PageLoading from "../../../../components/common/pageLoading/PageLoading";
import { useSelector } from "react-redux";
import { MobileDatePicker } from "@mui/x-date-pickers";
import styled from "styled-components";

import RowPerPageDropdown from "../../../../components/common/paginationRowPerpage/RowPerPageDropdown";
import Pagination from "../../../../components/common/Pagination";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    background: "#eaac35",
    color: "#ffffff",
    fontSize: "11px",
    fontFamily: "Poppins-Regular",
    padding: "5px 9px",
    lineHeight: "19px",
    borderRadius: "10px",
  },
}));

const ariaLabel = { "aria-label": "description" };

const MassDisbursementFormContent = ({
  bankList,
  searchedData, // This will now be the original, unsorted data
  filteredData, // This will be the data after search/filter/sort, used for display
  pageData,
  setPageData,
  searchTerm,
  setSearchTerm,
  filterType,
  setFilterType,
  filterYear,
  setFilterYear,
  rowPerPage,
  setRowPerPage,
  handleSort,
  sortColumn,
  sortDirection,
  handleBack,
  rollData,
  location,
}) => {
  const { values, handleChange, handleSubmit, touched, setFieldValue, handleBlur, errors,submitCount,isSubmitting } =
    useFormikContext();

  const handleCheckboxChange = (rowId, isChecked) => {
    const itemIndex = values.disbursed.findIndex((item) => item.id === rowId);
    if (itemIndex !== -1) {
      setFieldValue(`disbursed[${itemIndex}].isChecked`, isChecked);
      if (!isChecked) {
        const currentItem = values.disbursed[itemIndex];
        const lastInstallmentIndex = currentItem.disbursedInstallment.length - 1;
        setFieldValue(`disbursed[${itemIndex}].disbursedInstallment[${lastInstallmentIndex}].disbursedAmount`, "");
        const previousPendingAmount =
          lastInstallmentIndex > 0
            ? parseFloat(currentItem.disbursedInstallment[lastInstallmentIndex - 1]?.pendingAmount) || 0
            : parseFloat(currentItem?.ApproveAmount || 0);
        setFieldValue(`disbursed[${itemIndex}].disbursedInstallment[${lastInstallmentIndex}].pendingAmount`, previousPendingAmount);
      }
    }
  };

  const handleDisbursedAmountChange = (
    rowId,
    installmentIndex,
    newValue
  ) => {
    const parsedNewValue = parseFloat(newValue) || 0;

    const itemIndex = values.disbursed.findIndex((item) => item.id === rowId);
    if (itemIndex === -1) return;

    const currentItem = values.disbursed[itemIndex];
    const currentInstallments = currentItem.disbursedInstallment;

    const previousPendingAmount =
      installmentIndex > 0
        ? parseFloat(currentInstallments[installmentIndex - 1]?.pendingAmount) || 0
        : parseFloat(currentItem?.ApproveAmount || 0);

    let newPendingAmount = previousPendingAmount - parsedNewValue;
    if (parsedNewValue >= previousPendingAmount) {
      newPendingAmount = 0;
    }

    setFieldValue(
      `disbursed[${itemIndex}].disbursedInstallment[${installmentIndex}].disbursedAmount`,
      newValue
    );
    setFieldValue(
      `disbursed[${itemIndex}].disbursedInstallment[${installmentIndex}].pendingAmount`,
      newPendingAmount
    );
  };

  const totalCalculatedDisbursedAmount = useMemo(() => {
    return values?.disbursed
      ?.filter((row) => row.isChecked)
      .reduce((sum, row) => {
        const lastInstallment =
          row?.disbursedInstallment?.[
            row?.disbursedInstallment?.length - 1
          ];
        return sum + (parseFloat(lastInstallment?.disbursedAmount) || 0);
      }, 0);
  }, [values.disbursed]);


  return (
    <form onSubmit={handleSubmit}>
      <Index.Box className="main-in-row" sx={{ marginBottom: "16px" }}>
        <Index.Box className="user-basic user-heading">
          <Index.Typography component="h1" className="head-apply">
            Apply for mass disbursement
          </Index.Typography>
        </Index.Box>
      </Index.Box>
      <Index.Box className="main-in-row main-card-box">
        <Index.Box sx={{ flexGrow: 1 }} className="al-form-groups">
          <Index.Grid container spacing={2}>
            <Index.Grid item xs={12} sm={6} md={3} lg={3}>
              <Index.Box className="lable-input-grp">
                <Index.Typography component="p" className="in-label">
                  Voucher No (વાઉચર નં.)
                </Index.Typography>
                <Index.TextField
                  type="number"
                  inputProps={ariaLabel}
                  className="basic-input input-width"
                  name="VoucherNo"
                  value={values?.VoucherNo}
                  onChange={(e) => {
                    if (e.target.value.length <= 12) {
                      handleChange(e);
                    }
                  }}
                  onBlur={handleBlur}
                />
              </Index.Box>
              {errors?.VoucherNo && touched?.VoucherNo && (
                <p className="error-text">{errors?.VoucherNo}</p>
              )}
            </Index.Grid>
            <Index.Grid item xs={12} sm={6} md={3} lg={3}>
              <Index.Box className="lable-input-grp">
                <Index.Typography component="p" className="in-label">
                  Cheque No. (ચેક નં.)
                </Index.Typography>
                <Index.TextField
                  inputProps={ariaLabel}
                  className="basic-input input-width"
                  name="ChequeNo"
                  value={values?.ChequeNo}
                  onChange={(e) => {
                    if (e.target.value.length <= 10) {
                      handleChange(e);
                    }
                  }}
                  onBlur={handleBlur}
                />
              </Index.Box>
              {errors?.ChequeNo && touched?.ChequeNo && (
                <p className="error-text">{errors?.ChequeNo}</p>
              )}
            </Index.Grid>

            <Index.Grid item xs={12} sm={6} md={3} lg={3}>
              <Index.Box className="lable-input-grp">
                <Index.Typography component="p" className="in-label">
                  Bank Issue Name (બેંક ઇશ્યુનું નામ)
                </Index.Typography>
                <Index.Box className="sahay-multiple-input-main">
                  <Autocomplete
                    disablePortal
                    className="multiple-autocomplet-control"
                    id="combo-box-bank-issue"
                    options={bankList?.map((row) => row?.BankIssueName)}
                    getOptionLabel={(option) => option}
                    value={values?.BankIssueName || null}
                    onChange={(event, newValue) => {
                      setFieldValue("BankIssueName", newValue);
                    }}
                    onBlur={handleBlur}
                    renderInput={(params) => (
                      <Index.TextField
                        {...params}
                        placeholder="Select Bank Issue Name"
                      />
                    )}
                  />
                </Index.Box>
                {errors?.BankIssueName && touched?.BankIssueName && (
                  <p className="error-text">{errors?.BankIssueName}</p>
                )}
              </Index.Box>
            </Index.Grid>

            <Index.Grid item xs={12} sm={6} md={3} lg={3}>
              <Index.Typography component="p" className="in-label">
                Cheque Date (તારીખ તપાસો)
              </Index.Typography>
              <Index.Box className="input-design-div with-border date-input-box">
                <Index.LocalizationProvider dateAdapter={Index.AdapterDayjs}>
                  <Index.DemoContainer components={["DatePicker"]}>
                    <MobileDatePicker
                      name="chequeDate"
                      onChange={(value) => {
                        setFieldValue(
                          "chequeDate",
                          value ? moment(value.$d).format("YYYY-MM-DD") : null
                        );
                      }}
                      value={values?.chequeDate ? dayjs(values?.chequeDate) : null}
                      format="YYYY-MM-DD"
                      sx={{
                        overflowY: "hidden",
                        position: "relative",
                        bottom: "8px",
                        width: "100%",
                      }}
                      slotProps={{
                        textField: {
                          size: "small",
                          error: false,
                        },
                      }}
                    />
                  </Index.DemoContainer>
                </Index.LocalizationProvider>
              </Index.Box>
              {errors?.chequeDate && touched.chequeDate && (
                <p className="error-text">{errors?.chequeDate}</p>
              )}
            </Index.Grid>
            <Index.Grid item xs={12} sm={6} md={3} lg={3}>
              <Index.Typography component="p" className="in-label">
                Start Date (પ્રારંભ તારીખ)
              </Index.Typography>
              <Index.Box className="input-design-div with-border date-input-box">
                <Index.LocalizationProvider dateAdapter={Index.AdapterDayjs}>
                  <Index.DemoContainer components={["DatePicker"]}>
                    <MobileDatePicker
                      name="StartDate"
                      onChange={(value) => {
                        setFieldValue(
                          "StartDate",
                          value ? moment(value.$d).format("YYYY-MM-DD") : null
                        );
                      }}
                      value={values?.StartDate ? dayjs(values?.StartDate) : null}
                      format="YYYY-MM-DD"
                      sx={{
                        overflowY: "hidden",
                        position: "relative",
                        bottom: "8px",
                        width: "100%",
                      }}
                      slotProps={{
                        textField: {
                          size: "small",
                          error: false,
                        },
                      }}
                    />
                  </Index.DemoContainer>
                </Index.LocalizationProvider>
              </Index.Box>
              {errors?.StartDate && touched?.StartDate && (
                <p className="error-text">{errors?.StartDate}</p>
              )}
            </Index.Grid>
            <Index.Grid item xs={12} sm={6} md={3} lg={3}>
              <Index.Typography component="p" className="in-label">
                Check Issue date (ઇશ્યૂ તારીખ તપાસો)
              </Index.Typography>
              <Index.Box className="input-design-div with-border date-input-box">
                <Index.LocalizationProvider dateAdapter={Index.AdapterDayjs}>
                  <Index.DemoContainer components={["DatePicker"]}>
                    <MobileDatePicker
                      name="checkIssueDate"
                      onChange={(value) => {
                        setFieldValue(
                          "checkIssueDate",
                          value ? moment(value.$d).format("YYYY-MM-DD") : null
                        );
                      }}
                      value={values?.checkIssueDate ? dayjs(values?.checkIssueDate) : null}
                      format="YYYY-MM-DD"
                      sx={{
                        overflowY: "hidden",
                        position: "relative",
                        bottom: "8px",
                        width: "100%",
                      }}
                      slotProps={{
                        textField: {
                          size: "small",
                          error: false,
                        },
                      }}
                    />
                  </Index.DemoContainer>
                </Index.LocalizationProvider>
              </Index.Box>
              {errors?.checkIssueDate && touched.checkIssueDate && (
                <p className="error-text">{errors?.checkIssueDate}</p>
              )}
            </Index.Grid>

            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
              <Index.Box className="lable-input-grp">
                <Index.Typography component="p" className="in-label">
                  Total Disbursement Amount (કુલ વિતરણ રકમ)
                </Index.Typography>
                <Index.TextField
                  inputProps={{
                    ...ariaLabel,
                    onKeyDown: (e) => {
                      if (e.key === "-" || e.key === "Minus") {
                        e.preventDefault();
                      }
                    },
                  }}
                  onChange={(e) => {
                    let value = e.target.value;
                    if (parseFloat(value) >= 0 || value === "") {
                      handleChange(e);
                    }
                  }}
                  onBlur={handleBlur}
                  type="number"
                  className="basic-input input-width"
                  name="MassDisbursedAmount"
                  value={values?.MassDisbursedAmount}
                />
              </Index.Box>
              {errors?.MassDisbursedAmount && touched?.MassDisbursedAmount && (
                <p className="error-text">{errors?.MassDisbursedAmount}</p>
              )}
            </Index.Grid>

            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
              <Index.Box className="lable-input-grp">
                <Index.Typography component="p" className="in-label">
                  Remaining Disbursement Amount (વિતરણ રકમ)
                </Index.Typography>
                <Index.TextField
                  disabled
                  type="number"
                  inputProps={ariaLabel}
                  className="basic-input input-width"
                  name="AllMassDisbursedAmount"
                  value={
                    values?.MassDisbursedAmount - totalCalculatedDisbursedAmount
                  }
                />
              </Index.Box>
            </Index.Grid>
          </Index.Grid>
        </Index.Box>
      </Index.Box>
      <Index.Box
        sx={{ flexGrow: 1, marginTop: "15px" }}
        className="al-form-groups fam-in-grp multiple-doc mt-0px-sahay{"
      >
        <Index.Grid container spacing={2}>
          <Index.Grid item xs={12} sm={6} md={4} lg={4} mb={2}>
            <Index.Box className="lable-input-grp">
              <Index.Typography component="p" className="in-label">
                Add Multiple Document (બહુવિધ દસ્તાવેજ ઉમેરો)
              </Index.Typography>
              <Index.Box className="select-position">
                <input
                  type="file"
                  name="documents"
                  multiple
                  className="ori-input"
                  onChange={(event) => {
                    const files = Array.from(event.target.files);
                    setFieldValue("documents", [...values?.documents, ...files]);
                  }}
                />

                <Index.Box className="select-file">Upload Your Document</Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Grid>

          <Index.Grid item xs={8}>
            <Index.Box className="select-view-document-name">
              {values?.documents?.map((file, index) => (
                <Index.Box className="document-name" key={index}>
                  <Index.Typography
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      window.open(
                        file instanceof Blob
                          ? URL.createObjectURL(file)
                          : `${imagePath}${file?.Documents}`
                      );
                    }}
                  >
                    {file?.name ? file?.name : file?.filename}
                  </Index.Typography>
                  <Index.IconButton
                    onClick={() => {
                      const updatedDocuments = values.documents.filter(
                        (_, i) => i !== index
                      );
                      setFieldValue("documents", updatedDocuments);
                    }}
                  >
                    <Index.ClearIcon className="muiico-cancel" />
                  </Index.IconButton>
                </Index.Box>
              ))}
            </Index.Box>
          </Index.Grid>
        </Index.Grid>
      </Index.Box>
      <hr />

      <Index.Box
        className="search-filter-bar"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
          marginBottom: 2,
          marginTop: 2,
        }}
      >
        <Index.InputBase
          placeholder="Search by name or family ID"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="admin-table-search"
          sx={{
            minWidth: 250,
            backgroundColor: "#f9f9f9",
            borderRadius: 2,
            px: 2,
            border: "1px solid #cccccc",
            height: 42,
          }}
        />

        <Index.Select
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
          displayEmpty
          className="admin-table-filter"
          sx={{
            minWidth: 250,
            backgroundColor: "#f9f9f9",
            borderRadius: 2,
            px: 2,
            border: "1px solid #ddd",
            height: 42,
          }}
        >
          <Index.MenuItem value="">All Sahay Types</Index.MenuItem>
          {[...new Set(searchedData.map((item) => item.SahayTypeName))]
            .filter(Boolean)
            .map((type) => (
              <Index.MenuItem key={type} value={type}>
                {type}
              </Index.MenuItem>
            ))}
        </Index.Select>

        <Index.Select
          value={filterYear}
          onChange={(e) => {
            return setFilterYear(e.target.value);
          }}
          displayEmpty
          className="admin-table-filter"
          sx={{
            minWidth: 250,
            backgroundColor: "#f9f9f9",
            borderRadius: 2,
            px: 2,
            border: "1px solid #ddd",
            height: 42,
          }}
        >
          <Index.MenuItem value="">All Year</Index.MenuItem>
          {[
            ...new Set(
              searchedData.map(
                (item) =>
                  `${item.yearFrom}-${item.toYear}`
              )
            ),
          ]
            .filter(Boolean)
            .map((type) => (
              <Index.MenuItem key={type} value={type}>
                {type}
              </Index.MenuItem>
            ))}
        </Index.Select>
      </Index.Box>

      <Index.Box className="">
        <Index.TableContainer
          sx={{ maxHeight: 480 }}
          component={Index.Paper}
          className="table-container sahay-application-container scroll-table"
        >
          <Index.Table
            stickyHeader
            aria-label="sticky table"
            className="table-design-main barge-table sahay-appli-table"
          >
            <Index.TableHead className="sahay-appli-head">
              <Index.TableRow className="sahay-appli-tr">
                <Index.TableCell className="sahay-appli-tr"></Index.TableCell>
                <Index.TableCell className="sahay-appli-tr">Family Id</Index.TableCell>
                <Index.TableCell className="sahay-appli-tr" align="left">
                  Year
                </Index.TableCell>
                <Index.TableCell
                  className="user-sahay-td"
                  onClick={() => handleSort("userName")}
                  style={{ cursor: "pointer" }}
                >
                  User Name
                  {sortColumn === "userName" &&
                    (sortDirection === "asc" ? (
                      <SwapVertIcon className="swap-icon" fontSize="small" />
                    ) : (
                      <SwapVertIcon className="swap-icon" fontSize="small" />
                    ))}
                </Index.TableCell>
                <Index.TableCell className="sahay-appli-tr" align="left">
                  Sahay Category
                </Index.TableCell>
                <Index.TableCell className="sahay-appli-tr" align="left">
                  Sub Sahay Category
                </Index.TableCell>
                <Index.TableCell className="sahay-appli-tr" align="left">
                  Approved Amount
                </Index.TableCell>
                <Index.TableCell className="sahay-appli-tr" align="left">
                  Pending Amount
                </Index.TableCell>
                <Index.TableCell className="sahay-appli-tr" align="left" width="30%">
                  Disbursed Amount
                </Index.TableCell>
                <Index.TableCell className="sahay-appli-tr" align="left">
                  Staff Status
                </Index.TableCell>
                <Index.TableCell className="sahay-appli-tr" align="left">
                  Disbursement Status
                </Index.TableCell>
                <Index.TableCell className="sahay-appli-tr" align="left">
                  Committee Status
                </Index.TableCell>
                <Index.TableCell className="sahay-appli-tr" align="left">
                  Committee Remark
                </Index.TableCell>
              </Index.TableRow>
            </Index.TableHead>
            <Index.TableBody>
              <FieldArray name="disbursed">
                {({ remove, push }) => (
                  <>
                    {pageData?.length ? (
                      pageData.map((row,index) => {
                        // Formik values mein se is row ke liye data dhundhen
                        const formikRowIndex = values.disbursed.findIndex(item => item.id === row.id);
                        // console.log("formikRowIndex",formikRowIndex)
                        const formikRow = values.disbursed[formikRowIndex];
                        // console.log("first-formikRow",formikRow)
                        if (!formikRow) return null;

                        const lastInstallment =
                          formikRow?.disbursedInstallment?.[
                            formikRow?.disbursedInstallment?.length - 1
                          ];
                          // console.log("first-lastInstallment",lastInstallment)
                        const disbursedAmountError =
                          errors?.disbursed?.[formikRowIndex]?.disbursedInstallment?.[formikRow.disbursedInstallment.length - 1]?.disbursedAmount;
                        const disbursedAmountTouched =
                          touched?.disbursed?.[formikRowIndex]?.disbursedInstallment?.[formikRow.disbursedInstallment.length - 1]?.disbursedAmount;

                        return (
                          <Index.TableRow key={row.id} className={`sahay-appli-tr`}>
                            <Index.TableCell component="td" variant="td" scope="row" className="sahay-appli-td" align="left">
                              <Index.Checkbox
                                component="td"
                                variant="td"
                                scope="row"
                                className="check-box-role"
                                align="left"
                                checked={formikRow?.isChecked || false}
                                onChange={(e) => handleCheckboxChange(row.id, e.target.checked)}
                              />
                            </Index.TableCell>
                            <Index.TableCell align="left" className="sahay-appli-td">
                              {row?.familyId}
                            </Index.TableCell>
                            <Index.TableCell align="left" className="sahay-appli-td">
                              {row?.yearFrom} - {row?.toYear}
                            </Index.TableCell>
                            <Index.TableCell align="left" className="sahay-appli-td">
                              {row?.mem_fname} {row?.mem_mname} {row?.mem_lname}
                            </Index.TableCell>
                            <Index.TableCell align="left" className="sahay-appli-td">
                              {row?.SahayTypeName}
                            </Index.TableCell>
                            <Index.TableCell align="left" className="sahay-appli-td">
                              {row?.subSahayTypeName}
                            </Index.TableCell>
                            <Index.TableCell align="left" className="sahay-appli-td">
                              {row?.ApproveAmount}
                            </Index.TableCell>
                            <Index.TableCell align="left" className="sahay-appli-td">
                              {lastInstallment?.pendingAmount ?? "-"}
                            </Index.TableCell>
                            <Index.TableCell align="left" className="sahay-appli-td">
                              <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                <Index.TextField
                                  inputProps={{
                                    ...ariaLabel,
                                    disabled: !formikRow?.isChecked, // Checkbox check na hone par disable karein
                                    onKeyDown: (e) => {
                                      if (e.key === "-" || e.key === "Minus") {
                                        e.preventDefault();
                                      }
                                    },
                                  }}
                                  className="basic-input input-width"
                                  name={`disbursed[${formikRowIndex}].disbursedInstallment[${formikRow.disbursedInstallment.length - 1}].disbursedAmount`}
                                  type="number"
                                  value={lastInstallment?.disbursedAmount || ""}
                                  onChange={(e) => {
                                    const newValue = parseFloat(e.target.value) || 0;
                                    // console.log("disbursedInstallment",formikRow?.disbursedInstallment?.length)
                                     if(formikRow?.disbursedInstallment?.length > 1){
                                      return
                                    }
                                    const currentInstallmentIndex = formikRow?.disbursedInstallment?.length - 1 || 0;
                                    const previousInstallment = row?.disbursedInstallment?.[currentInstallmentIndex - 1];
                                   
                                    const previousPendingAmount =
                                      currentInstallmentIndex > 0 && previousInstallment
                                        ? parseFloat(previousInstallment?.pendingAmount || 0)
                                        : parseFloat(row?.ApproveAmount || 0);
                                    if (!previousPendingAmount || previousPendingAmount <= 0) {
                                      return;
                                    }
                                    const newPendingAmount = previousPendingAmount - newValue;
                                    if (newPendingAmount < 0) {
                                      return;
                                    }
                                    handleDisbursedAmountChange(
                                      row.id,
                                      currentInstallmentIndex,
                                      newValue
                                    );
                                  }}

                                  // onChange={(e) => {
                                  //   const currentInstallmentIndex = formikRow?.disbursedInstallment?.length - 1 || 0;
                                  //   const previousInstallment = row?.disbursedInstallment?.[currentInstallmentIndex - 1];

                                  //   const previousPendingAmount =
                                  //     currentInstallmentIndex > 0 && previousInstallment
                                  //       ? parseFloat(previousInstallment?.pendingAmount || 0)
                                  //       : parseFloat(row?.ApproveAmount || 0);

                                  //   const newValue = parseFloat(e.target.value) || 0;
                                  //   const newPendingAmount = previousPendingAmount - newValue;

                                  //   // 💡 Don't allow if no pending amount
                                  //   if (previousPendingAmount <= 0) {
                                  //     // optional: show message or just disable input
                                  //     return;
                                  //   }

                                  //   // 💡 Don't allow to over-disburse
                                  //   if (newPendingAmount < 0) {
                                  //     return;
                                  //   }

                                  //   // ✅ Safe call
                                  //   handleDisbursedAmountChange(
                                  //     row.id,
                                  //     currentInstallmentIndex,
                                  //     newValue
                                  //   );
                                  //   // const newValue = parseFloat(e.target.value) || 0;
                                  //   // const currentInstallmentIndex = formikRow.disbursedInstallment.length - 1;
                                  //   // console.log("first-currentInstallmentIndex",currentInstallmentIndex)
                                  //   // console.log("first-row-data",row?.disbursedInstallment[currentInstallmentIndex - 1])

                                  //   // const previousPendingAmount =
                                  //   //   currentInstallmentIndex > 0
                                  //   //     ? parseFloat(
                                  //   //         row?.disbursedInstallment[currentInstallmentIndex - 1]?.pendingAmount
                                  //   //       ) || 0
                                  //   //     : parseFloat(row?.ApproveAmount || 0);
                                  //   //   // console.log("first-previousPendingAmount",previousPendingAmount)
                                  //   // const newPendingAmount = previousPendingAmount - newValue;
                                  //   // // console.log("first-newPendingAmount",newPendingAmount)
                                  //   // if (newPendingAmount < 0) {
                                  //   //   return;
                                  //   // } else {
                                  //   //   handleDisbursedAmountChange(
                                  //   //     row.id,
                                  //   //     currentInstallmentIndex,
                                  //   //     newValue
                                  //   //   );
                                  //   // }
                                  // }}
                                  onBlur={handleBlur}
                                />
                              </Index.Grid>
                              {formikRow?.isChecked && disbursedAmountTouched && disbursedAmountError && (
                                <p className="error-text">{disbursedAmountError}</p>
                              )}
                            </Index.TableCell>
                            <Index.TableCell align="left" className="sahay-appli-td">
                              <Index.Box
                                className={`status-details ${
                                  row?.newStatusColumn === "Pending"
                                    ? "pending - status"
                                    : row?.newStatusColumn === "Approved"
                                    ? "approved-status"
                                    : row?.newStatusColumn === "Rejected"
                                    ? "reject-status"
                                    : ""
                                }`}
                              >
                                {row?.newStatusColumn}
                              </Index.Box>
                            </Index.TableCell>
                            <Index.TableCell align="left" className="sahay-appli-td" sx={{ textAlign: "center" }}>
                              <Index.Box
                                className={`status-details ${
                                  row?.isDisbursed === 0
                                    ? "pending - status"
                                    : row?.isDisbursed === 1
                                    ? "approved-status"
                                    : ""
                                }`}
                              >
                                {row?.isDisbursed === 0 && row?.disbursedStatus === null
                                  ? "Pending"
                                  : row?.isDisbursed === 1 &&
                                    (row?.disbursedStatus === "Complete" ||
                                      row?.disbursedStatus === null)
                                  ? "Completed"
                                  : row?.isDisbursed === 0 &&
                                    row?.disbursedStatus === "PartialyPending"
                                  ? "Partially Pending"
                                  : "-"}
                              </Index.Box>
                            </Index.TableCell>
                            <Index.TableCell align="left" className="sahay-appli-td" sx={{ textAlign: "center" }}>
                              <Index.Box
                                className={`status-details ${
                                  row?.committeeStatus === "Pending"
                                    ? "pending - status"
                                    : row?.committeeStatus === "Approved"
                                    ? "approved-status"
                                    : row?.committeeStatus === "Rejected"
                                    ? "reject-status"
                                    : ""
                                }`}
                              >
                                {row?.committeeStatus === null ? "-" : row?.committeeStatus}
                              </Index.Box>
                            </Index.TableCell>
                            <Index.TableCell align="left" className="sahay-appli-td" sx={{ textAlign: "center" }}>
                              {row?.committeeRemark === "null" ? (
                                "-"
                              ) : row?.committeeRemark === "undefined" ? (
                                "-"
                              ) : row?.committeeRemark === null ? (
                                "-"
                              ) : (
                                <LightTooltip title={row?.committeeRemark}>
                                  {row.committeeRemark?.split(" ")?.slice(0, 3)?.join(" ")}
                                </LightTooltip>
                              )}
                            </Index.TableCell>
                          </Index.TableRow>
                        );
                      })
                    ) : (
                      <PagesIndex.NoRecordFound colSpan={12} />
                    )}
                  </>
                )}
              </FieldArray>
            </Index.TableBody>
          </Index.Table>
        </Index.TableContainer>
        {/* Table-wide error for "At least one item must be selected" */}
        {/* {errors?.disbursed && typeof errors.disbursed === 'string' && (
          <p className="error-text">{errors.disbursed}</p>
        )} */}
        {/* {typeof errors?.customCheckError === 'string' && ( */}
        {(submitCount > 0 || touched.disbursed) && errors.customCheckError && (
          <div className="error-text">
            {errors?.customCheckError}
          </div>
        )}
      </Index.Box>
      <Index.Box className="pagination-design flex-end">
        <RowPerPageDropdown rowPerPage={rowPerPage} setRowPerPage={setRowPerPage} />
        <Index.Stack spacing={2}>
          <Pagination
            fetchData={filteredData}
            setPageData={setPageData}
            pageData={pageData}
            rowPerPage={rowPerPage}
          />
        </Index.Stack>
      </Index.Box>

      <Index.Box sx={{ flexGrow: 1 }} className="al-form-groups fam-in-grp">
        <Index.Grid item xs={6}>
          <Index.Box className="common-button blue-button flex-end save-btn back-btn">
            <Index.Button variant="contained" onClick={() => handleBack()}>
              Back
            </Index.Button>
          </Index.Box>
        </Index.Grid>
        <Index.Grid container spacing={2}>
          <Index.Grid item xs={6}>
            <Index.Box className="lable-input-grp ">
              <Index.Box className="select-position">
                  <Index.Box className="apply-now">
                    <button disabled={isSubmitting}  type="submit">{isSubmitting ? "Loading..." :"Submit"}</button>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Grid>
          </Index.Grid>
        </Index.Box>
    </form>
  );
};

const MassDisbursement = () => {
  const theme = useTheme();
  const dispatch = PagesIndex.useDispatch();
  const navigate = PagesIndex.useNavigate();
  const location = PagesIndex.useLocation();
  const rollData = JSON.parse(localStorage?.getItem("RollName"))?.toLowerCase();

  const [pageLoader, setPageLoader] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [pageData, setPageData] = useState([]); // Current page's data
  const [searchedData, setSearchedData] = React.useState([]); // All original data from API
  const [sortColumn, setSortColumn] = useState("userName");
  const [sortDirection, setSortDirection] = useState("asc");
  const [rowPerPage, setRowPerPage] = useState("25");
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterYear, setFilterYear] = useState("");
  const [filteredAndSortedData, setFilteredAndSortedData] = useState([]);

  const getAllBanksList = () => {
    dispatch(getAllBankList()).then((res) => {
      if (res?.payload) {
        setBankList(res?.payload?.data);
      } else {
        setBankList([]);
      }
    });
  };

  const getDisbursementData = () => {
    dispatch(getDisbursementDataList()).then((data) => {
      if (data?.payload) {
        const filterData = data?.payload?.filter((ele) => {
          return (
            (ele?.isDisbursed === 0 && ele?.disbursedStatus === null) ||
            (ele?.isDisbursed === 0 && ele?.disbursedStatus === "PartialyPending")
          );
        });
        setSearchedData(filterData); // Set the original data here
      }
    });
  };

  useEffect(() => {
    getAllBanksList();
    getDisbursementData();
  }, []);

  const handleSort = (column) => {
    const isAsc = sortColumn === column && sortDirection === "asc";
    const newSortDirection = isAsc ? "desc" : "asc";
    setSortDirection(newSortDirection);
    setSortColumn(column);

    // Sorting will be applied in the useEffect that calculates filteredAndSortedData
  };

  const { rollPermissionData } = useSelector((state) => state.admin);

  useEffect(() => {
    if (
      !rollPermissionData?.permissionArray?.includes("Disbursement_add") &&
      !rollPermissionData?.permissionArray?.includes("Disbursement_edit")
    ) {
      navigate(`/${rollData}/sahay-application`);
    }
  }, [rollPermissionData, rollData, navigate]);

  // Effect to apply search, filter, and sort
  useEffect(() => {
    let currentFilteredData = searchedData.filter((row) => {
      const fullName = `${row.mem_fname} ${row.mem_mname} ${row.mem_lname}`.toLowerCase();
      const familyIdStr = row.familyId?.toString() || "";

      const matchesSearch =
        fullName.includes(searchTerm.toLowerCase()) || familyIdStr.includes(searchTerm);

      const matchesFilter = filterType === "" || row.SahayTypeName === filterType;
      const matchYearFilter = filterYear === "" || `${row?.yearFrom}-${row?.toYear}` === filterYear;

      return matchesSearch && matchesFilter && matchYearFilter;
    });

    // Apply sorting to the filtered data
    const sortedData = [...currentFilteredData].sort((a, b) => {
      if (sortColumn === "userName") {
        const nameA = `${a.mem_fname} ${a.mem_lname}`.toLowerCase();
        const nameB = `${b.mem_fname} ${b.mem_lname}`.toLowerCase();
        return sortDirection === "asc" ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
      }
      // Add other sorting columns here if needed
      return 0;
    });

    setFilteredAndSortedData(sortedData);
  }, [searchedData, searchTerm, filterType, filterYear, sortColumn, sortDirection]);


  // Effect to handle pagination
  // useEffect(() => {
  //   if(rowPerPage == "All"){
  //     setPageData(filteredAndSortedData)
  //   }else{
  //     const startIndex = (currentPage - 1) * parseInt(rowPerPage);
  //     const endIndex = startIndex + parseInt(rowPerPage);
  //     setPageData(filteredAndSortedData.slice(startIndex, endIndex));
  //   }
    
  // }, [filteredAndSortedData, rowPerPage]);


  const initialFormikValues = useMemo(() => {
    const disbursedItems = searchedData?.map((row) => {
      const existingDisbursedData =
        row?.DisbursedData && row?.DisbursedData?.length > 0
          ? row?.DisbursedData[row?.DisbursedData?.length - 1]
          : null;

      return {
        id: row?.id,
        isChecked: false,
        familyId: row?.familyId,
        yearFrom: row?.yearFrom,
        toYear: row?.toYear,
        mem_fname: row?.mem_fname,
        mem_mname: row?.mem_mname,
        mem_lname: row?.mem_lname,
        SahayTypeName: row?.SahayTypeName,
        subSahayTypeName: row?.subSahayTypeName,
        ApproveAmount: row?.ApproveAmount,
        newStatusColumn: row?.newStatusColumn,
        disbursedStatus: row?.disbursedStatus,
        committeeStatus: row?.committeeStatus,
        committeeRemark: row?.committeeRemark,
        isDisbursed: row?.isDisbursed,
        disbursedInstallment: [
          ...(row?.DisbursedData || []),
          {
            disbursedAmount: "",
            pendingAmount: existingDisbursedData
              ? existingDisbursedData.pendingAmount
              : row?.ApproveAmount,
            disbursedDate: new Date(),
          },
        ],
      };
    });

    return {
      VoucherNo: "",
      checkIssueDate: "",
      RepayDetail: "",
      BankIssueName: "",
      ChequeNo: "",
      chequeDate: "",
      StartDate: "",
      documents: [],
      MassDisbursedAmount: "",
      disbursed: disbursedItems || [],
    };
  }, [searchedData]); // Dependency on searchedData (original data) to ensure stable IDs for Formik

  const handleFormSubmit = (values, { setFieldValue }) => {
    const data = new FormData();

    data.append("BankIssueName", values?.BankIssueName || "");
    data.append("ChequeNo", values?.ChequeNo || "");
    data.append("ChequeDate", values?.chequeDate || "");
    data.append("RepayDetail", values?.RepayDetail || "");
    data.append("StartDate", values?.StartDate || "");
    data.append("VoucherNo", values?.VoucherNo || "");
    data.append("CheckIssueDate", values?.checkIssueDate || "");
    data.append("MassDisbursedAmount", values?.MassDisbursedAmount || "");

    values?.disbursed
      ?.filter?.((row) => row?.isChecked === true)
      ?.forEach((sahay, index) => {
        data.append(`SahayIds[${index}][SahayId]`, sahay?.id);
      });

    values?.disbursed
      ?.filter?.((row) => row?.isChecked === true)
      ?.forEach((amount, index) => {
        const lastInstallment =
          amount?.disbursedInstallment[amount?.disbursedInstallment?.length - 1];

        data.append(`disbursed[${index}][SahayId]`, amount?.id);
        data.append(`disbursed[${index}][approvedAmount]`, amount?.ApproveAmount);
        data.append(
          `disbursed[${index}][disbursedAmount]`,
          lastInstallment?.disbursedAmount || ""
        );
        data.append(
          `disbursed[${index}][pendingAmount]`,
          lastInstallment?.pendingAmount || ""
        );
        data.append(
          `disbursed[${index}][disbursedDate]`,
          moment(lastInstallment?.disbursedDate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
        );

        data.append(`disbursed[${index}][BankIssueName]`, values?.BankIssueName || "");
        data.append(`disbursed[${index}][ChequeNo]`, values?.ChequeNo || "");
        data.append(`disbursed[${index}][ChequeDate]`, values?.chequeDate || "");
        data.append(`disbursed[${index}][RepayDetail]`, values?.RepayDetail || "");
        data.append(`disbursed[${index}][StartDate]`, values?.StartDate || "");
        data.append(`disbursed[${index}][VoucherNo]`, values?.VoucherNo || "");
        data.append(`disbursed[${index}][CheckIssueDate]`, values?.checkIssueDate || "");
      });

    if (values?.documents?.length > 0) {
      values?.documents?.forEach((ele) => {
        if (ele instanceof Blob) {
          data.append("documents", ele);
        } else {
          data.append("oldDocuments", ele?.Documents);
        }
      });
    }

    dispatch(addMassDisbursementData(data)).then((res) => {
      if (res?.payload?.status === 201) {
        navigate(`/${rollData}/disbursement-application`);
      }
    });
  };

  const handleBack = () => {
    navigate(`/${rollData}/disbursement-application`);
  };

  return (
    <>
      <div>
        {pageLoader ? (
          <PageLoading />
        ) : (
          <>
            <Index.Box className="apply-sahay-main">
              <Index.Box className="head-content">
                <Index.Box
                  className={`user-right ${
                    location.pathname === "/admin/add-disbursement-application"
                      ? "admin-border-radius"
                      : ""
                  }`}
                >
                  <Index.Box
                    className={`bottom-user-right ${
                      location.pathname === "/admin/add-disbursement-application"
                        ? "admin-height-remove"
                        : ""
                    }`}
                  >
                    <Index.Box className="user-apply-content">
                      <Formik
                        enableReinitialize={true} // Yah mahatvapurna hai taki initialValues badalne par form re-initialize ho
                        onSubmit={handleFormSubmit}
                        initialValues={initialFormikValues}
                        validationSchema={massDisbursementSchema}
                        context={{ isChecked: false }}
                      >
                        {() => (
                          <MassDisbursementFormContent
                            bankList={bankList}
                            searchedData={searchedData} // Original data for filters
                            filteredData={filteredAndSortedData} // Data after filter and sort for pagination
                            pageData={pageData}
                            setPageData={setPageData}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            filterType={filterType}
                            setFilterType={setFilterType}
                            filterYear={filterYear}
                            setFilterYear={setFilterYear}
                            rowPerPage={rowPerPage}
                            setRowPerPage={setRowPerPage}
                            handleSort={handleSort}
                            sortColumn={sortColumn}
                            sortDirection={sortDirection}
                            handleBack={handleBack}
                            rollData={rollData}
                            location={location}
                          />
                        )}
                      </Formik>

                      <Index.Box className="title-header-flex "></Index.Box>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </>
        )}
      </div>
    </>
  );
};

export default MassDisbursement;
